import { render, staticRenderFns } from "./DashboardInvitations.vue?vue&type=template&id=14a18bb6&scoped=true"
import script from "./DashboardInvitations.vue?vue&type=script&lang=js"
export * from "./DashboardInvitations.vue?vue&type=script&lang=js"
import style0 from "./DashboardInvitations.vue?vue&type=style&index=0&id=14a18bb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a18bb6",
  null
  
)

export default component.exports